/**
 * Id do <filter> montado por LensDefs.tsx.
 *
 * glass.css referencia o mesmo valor via `url(#porquinho-lens)` — CSS não
 * importa constante de TS, então a duplicação é inevitável. Ver o comentário
 * ao lado de `backdrop-filter: url(#porquinho-lens)` em glass.css: se este
 * valor mudar, aquele precisa mudar junto.
 *
 * Em módulo próprio para manter a constante junto da nota acima, num lugar só.
 * Não é exigência do react-refresh: com `allowConstantExport: true`, exportar
 * um literal ao lado de um componente é permitido. Só export não-literal —
 * como o array TABS da TabBar — é que obriga a extração.
 */
export const LENS_FILTER_ID = 'porquinho-lens'

